import { useEffect, useRef } from 'react';

import type { AnyObject } from '../../../../../../types';
import { useLogAnalyticsEvent } from '../../../../../../hooks/useLogAnalyticsEvent';

type UseLogViewFilterBottomSheetProps = {
  logging: AnyObject | undefined;
};
export const useLogViewFilterBottomSheet = ({
  logging,
}: UseLogViewFilterBottomSheetProps) => {
  const hasLogged = useRef(false);

  const logAnalyticsEvent = useLogAnalyticsEvent();

  useEffect(() => {
    if (!logging || hasLogged.current) {
      return;
    }
    hasLogged.current = true;

    logAnalyticsEvent({
      name: 'VIEW_FILTER',
      ably_only_log: logging.ably_only_log,
      analytics: {
        ...logging.analytics.analytics,
        SCREEN: 'FILTER',
      },
    });
  }, [logging, logAnalyticsEvent]);
};
